module.exports = __webpack_public_path__ + "static/img/cont18.3d912cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont18.jpg
// module id = jfiT
// module chunks = 0